<template>
  <el-dialog :visible.sync="visible" width="70%" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '170px'">
      
      <h3>机构信息</h3>
      <div class="inline-box">
        <el-form-item label="金融产品所属机构" prop="publishChannels" class="styW" >
          <!-- publishChannels -->
          <el-select v-model="dataForm.publishChannels" filterable clearable placeholder="请输入" class="hundred">
           <el-option 
                     v-for="item in publishChannels"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
           ></el-option>
         </el-select>
         
        </el-form-item>
        <el-form-item label="BD/PM" prop="bdPm" class="styW" >
          <el-input v-model="dataForm.bdPm" placeholder="请输入"></el-input>
        </el-form-item>
      </div>
      <h3>产品大纲</h3>
      <div class="inline-box">
      <el-form-item label="产品大类" prop="productCategory" class="styW" >
         <el-select v-model="dataForm.productCategory" filterable clearable placeholder="请输入" class="hundred">
           <el-option 
                     v-for="item in productCategories"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
           ></el-option>
         </el-select>
      </el-form-item>
      <el-form-item label="产品类型" prop="productType" class="styW">
        <el-select v-model="dataForm.productType" filterable clearable placeholder="请输入" class="hundred">
          <el-option 
                    v-for="item in productTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
          </el-option>
        </el-select>
    </el-form-item>
      <el-form-item label="产品名称" prop="productName" class="styW" >
          <el-input v-model="dataForm.productName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="产品有效时间" prop="productLimit" class="styW" >
       <el-date-picker
               v-model="dataForm.productLimit"
               type="date"
               placeholder="产品有效时间"
               value-format="yyyy-MM-dd HH:mm:ss">
       </el-date-picker>
      </el-form-item>
      
        <el-form-item  label="产品log" prop="productLogo" class="hundred" >
          <el-upload
            v-model="dataForm.productLogo"
            :action="logUrl"
            :on-preview="handlePictureCardPreview"
            list-type="picture-card"
            :on-remove="handleRemove"
            :limit="1"
            :headers="headers"
            :file-list="fileList"
            :on-success="successHandle"
            >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible"  append-to-body>
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        </el-form-item>
        <el-form-item label="最高额度" prop="maximumAmount" class="styW" >
          <div style="display: flex;">
            <el-input v-model="dataForm.maximumAmount" placeholder="请输入"></el-input>万
          </div>
            
        </el-form-item>
        <el-form-item label="还款方式" prop="repaymentType" class="styW">
          <el-input v-model="dataForm.repaymentType" placeholder="请输入"></el-input>
        </el-form-item>
       <el-form-item label="贷款利率" prop="productRate" class="styW">
          <el-input v-model="dataForm.productRate" placeholder="请输入"></el-input>
       </el-form-item>
  
      <el-form-item label="提前还款" prop="prepayment" class="styW">
          <el-select v-model="dataForm.prepayment" filterable clearable placeholder="请输入" class="hundred">
            <el-option 
                      v-for="item in withdrawal"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="贷款期限" prop="loanTerm" class="styW">
          <el-input v-model="dataForm.loanTerm" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark" class="styW">
          <el-input v-model="dataForm.remark" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="准入区域" prop="productAccessArea" class="hundred">
          <el-button type="" @click="productAccessAreas()">准入区域设置</el-button>
      </el-form-item> 
    </div>
     
    <h3>进件要求</h3>
      <el-form-item label="个人准入要求" prop="productPersonCondition"  class="hundred">
          <wealth v-model="dataForm.productPersonCondition" :valuemy="dataForm.productPersonCondition"></wealth>
      </el-form-item> 

      <el-form-item label="征信要求" prop="productCreditRequirement"  class="hundred">
        <wealth v-model="dataForm.productCreditRequirement" :valuemy="dataForm.productCreditRequirement"></wealth>
      </el-form-item> 

      <el-form-item label="企业准入要求" prop="productCompanyCondition"  class="hundred">
          <wealth v-model="dataForm.productCompanyCondition" :valuemy="dataForm.productCompanyCondition"></wealth>
      </el-form-item> 
      
      <el-form-item label="其他要求" prop="productOtherRequirement" class="hundred">
          <wealth v-model="dataForm.productOtherRequirement" :valuemy="dataForm.productOtherRequirement"></wealth>
      </el-form-item>
      <h3>进件资料</h3>
      <el-form-item label="进件资料" prop="productApplyInfo"  class="hundred">
          <wealth  v-model="dataForm.productApplyInfo" :valuemy="dataForm.productApplyInfo"></wealth>
      </el-form-item> 

      <h3>分润设置</h3>
      <el-form-item label="结算状态" prop="settlementStatus" class="styW">
          <el-select v-model="dataForm.settlementStatus" filterable clearable placeholder="请选择" class="hundred">
            <el-option 
                      v-for="item in closeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
      
      <div class="shareProfit">
       
          <el-row :gutter="20">
            <el-col :span="4" style="opacity: 0;"> 0</el-col>
            <el-col :span="4" style="opacity: 0;"> 0</el-col>
            <el-col :span="4">提成比例</el-col>
            <el-col :span="1" style="opacity: 0;"> 0</el-col>
            <el-col :span="4">活动奖励</el-col>
            <el-col :span="4">计提总量</el-col>
          </el-row>
      
        <br>
        <div v-for=" (item,index) in dataForm.slProductAward" :key="index">
        <el-row :gutter="24">
            <el-col :span="4">{{ getText(item.slUserVipLevelId) }}</el-col>
            <el-col :span="4">h5显示</el-col>
            <el-col :span="4">
               <el-form-item label-width="0"  :prop="`slProductAward.${index}.h5AwardRate`" :rules="[{required: true, message: $t('validate.required'), trigger: 'blur'}]"   class="hundred">
                <el-input-number size="small" v-model="dataForm.slProductAward[index].h5AwardRate" controls-position="right" @change="handleChange(item.h5AwardRate,item.accrualRate,index,1)" :precision="2" :step="0.1" :min="0" ></el-input-number>%
              </el-form-item>
            </el-col>
            <el-col :span="1">+</el-col>
            <el-col :span="4">
              <el-form-item label-width="0" :prop="`slProductAward.${index}.h5ActiveRate`" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }"  class="hundred">
              <el-input-number  size="small" v-model="dataForm.slProductAward[index].h5ActiveRate" controls-position="right" @change="handleChange(item.h5ActiveRate,item.accrualRate,index,2)" :precision="2" :step="0.1" :min="0" ></el-input-number>元/笔
            </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="0" :prop="`slProductAward.${index}.accrualRate`" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }"  class="hundred">
                <el-input-number size="small" v-model="dataForm.slProductAward[index].accrualRate" controls-position="right" @change="handleChange(item.h5ActiveRate,item.accrualRate,index,3,item.h5AwardRate)" :min="0" ></el-input-number>%
             </el-form-item>
            </el-col>
        </el-row>
        <br>
        <el-row :gutter="24">
            <el-col :span="4" style="opacity: 0;">0</el-col>
            <el-col :span="4">
              管理后台显示
            </el-col>
            <el-col :span="4"><el-input-number size="small" v-model="dataForm.slProductAward[index].backAwardRate"  :precision="2" :step="0.1"  controls-position="right" disabled></el-input-number>%</el-col>
            <el-col :span="1" >+</el-col>
            <el-col :span="4"><el-input-number size="small" v-model="dataForm.slProductAward[index].backActiveRate"  :precision="2" :step="0.1"  controls-position="right" disabled></el-input-number>元/笔</el-col>
            <el-col :span="4" style="opacity: 0;">0</el-col>
        </el-row>
      </div>
       
       
      </div>
    
      <h3>申请流程</h3>
      <el-form-item  label="申请详细流程说明链接" prop="applyStep"  class="hundred">
        
          <el-select v-model="dataForm.applyStep" multiple filterable clearable placeholder="请选择" class="hundred">
	          <el-option
	                  v-for="item in productApplyFlow"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>

      
      <h3>上架配置</h3>
        <el-form-item label="上架" prop="status" class="styW">
          <el-select v-model="dataForm.status" filterable clearable placeholder="请选择" class="hundred">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
       </el-form-item> 
       <div class="inline-box">
       <el-form-item label="产品对接方式" prop="productDockingMethod" class="styW">
          <el-select v-model="dataForm.productDockingMethod" filterable clearable placeholder="请选择" class="hundred">
	          <el-option
	                  v-for="item in productTypes"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
       </el-form-item> 
       <el-form-item v-if="dataForm.productDockingMethod == 0" label="H5链接" prop="productDockingMethodUrl" >
          <el-input v-model="dataForm.productDockingMethodUrl" placeholder="请输入"></el-input>
       </el-form-item> 
       <el-form-item v-else label="上传二维码" prop="productDockingMethodUrl" >
            <el-upload
               v-model="dataForm.productDockingMethodUrl"
              :action="logUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="successHandle1"
              :headers="headers"
              :file-list="fileList1"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
       </el-form-item> 
      </div>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    <el-dialog
      width="60%"
      title="准入区域设置"
      :visible.sync="innerVisible"
      append-to-body>
      <accessArea ref="cityRef"></accessArea>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="innerVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="gitCity()">确 定</el-button>
      </div>
    </el-dialog>
   
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import wealth from '../../../components/wealth.vue'
import accessArea from '../../../components/wx/accessArea.vue'
import cityobj from '@/utils/city'
import Cookies from 'js-cookie'
import { getList } from '../../../api/list'
export default{
  data () {
    return {
      headers: {token: Cookies.get('token')},
      fileList: [],
      fileList1: [],
      vipLevels: [],
      logUrl:`${window.SITE_CONFIG['apiURL']}/sys/slproduct/uploadLogo`,
      dialogImageUrl: '',
      dialogVisible: false,
      visible: false,
      innerVisible: false,
      citys: [],
      cityobj: cityobj,
      productTypeList: [],
      productCategories: [],
      closeList:[],
      statusList: [
          {
          label: '禁用',
          value: 0,
        },
        {
          label: '启用',
          value: 1,
        },
      ],
      productTypes: [],
      productApplyFlow: [],
      publishChannels: [],
    
      dataForm: {
        maximumAmount: '',
        productDockingMethodUrl: '',
        productDockingMethod: '',
        slProductAward: [],
        settlementStatus: '',
        loanTerm: '',
        remark: '',
        prepayment: '',
        bdPm: '',
        id: '',
        productCode: '',
        productName: '',
        productLogo: '',
        productCategory: '',
        productType: '',
        creditAmount: '',
        maxRebate: '',
        productRate: '',
        productLimit: '',
        repaymentType: '',
        productNotice: '',
        productRequiredinfo: '',
        productRebateInfo: '',
        productCompanyCondition: '',
        productPersonCondition: '',
        productCreditRequirement: '',
        productOtherRequirement: '',
        productAccessArea: '',
        productApplyInfo: '',
        applyStep: '',
        productOtherCondition: '',
        productSettlementMode: '',
        productIntro: '',
        productExplain: '',
        productLevel: '',
        publishChannels: '',
        publishTime: '',
        unshelveTime: '',
        unshelveRemark: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        status: '',
        channelPm:'',
      },
      withdrawal: [],
      dataRule: {
      maximumAmount: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productDockingMethod: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productDockingMethodUrl: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      settlementStatus: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      loanTerm: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
     
      prepayment: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      bdPm: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],

      channelPm: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productCode: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productName: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productLogo: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productCategory: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productType: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      creditAmount: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      maxRebate: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productRate: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productLimit: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      repaymentType: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productNotice: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productRequiredinfo: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productRebateInfo: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      // productCompanyCondition: [
      //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      // ],
      // productPersonCondition: [
      //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      // ],
      // productCreditRequirement: [
      //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      // ],
      // productOtherRequirement: [
      //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      // ],
      productAccessArea: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productApplyInfo: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      applyStep: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productOtherCondition: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productSettlementMode: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productIntro: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productExplain: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      productLevel: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      publishChannels: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      publishTime: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      unshelveTime: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      unshelveRemark: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      updateBy: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      updateTime: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      deleteTime: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ],
      status: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      ]
    }
    }
  },
 
  components:{
    wealth,
    accessArea,
  },
  methods: {
    init () {
      this.visible = true
      this.fileList = []
      this.fileList1 = []
      this.getCityOptions()
      this.getProductTypeOptions()
      this.getproductCategoriesOptions()
      this.getcloseListCategoriesOptions()
      this.getproductTypesOptions()
      this.getapplyStepOptions()
      this.gitShareProfit()
      this.getvipLevelOptions()
      this.getpublishChannelsOptions()
      this.getwithdrawalOptions()
      this.cityobj.provinces.forEach(item => {
            item.istrue = false
            item.isIndeterminate = false
            item.cities.forEach(item1 => {
                item1.istrue = false
            })
        })
    
    },
    handleChange(n1,n2,index,type,n3) {
      if(type == 1){
        this.dataForm.slProductAward[index].backAwardRate = (n1 + n1 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
        return
      }
      if(type == 2){
        this.dataForm.slProductAward[index].backActiveRate = (n1 + n1 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
        return
      }

      this.dataForm.slProductAward[index].backAwardRate = (n3 + n3 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
      this.dataForm.slProductAward[index].backActiveRate = (n1 + n1 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
      },
      // 图片
    handleRemove(file, fileList) {
        console.log(file, fileList);
      },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    successHandle(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.productLogo = res.data
    },
    successHandle1(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.productDockingMethodUrl = res.data
    },
    productAccessAreas(){
        this.innerVisible = true
        this.$nextTick(()=>{
         
          if(this.dataForm.id){
            this.$refs.cityRef.init(JSON.parse(this.dataForm.productAccessArea))
          }else{
            this.$refs.cityRef.init(this.cityobj)
          }
        })
      
    },
    getText(txt){
        return this.vipLevels.filter(item => item.value == txt)[0]?.label
    },
  async  gitShareProfit(){
     let res = await this.$http.get(`/sys/slproductaward/award`)
    
      this.dataForm.slProductAward = res.data.data
      console.log(this.dataForm.slProductAward)
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    
    },
  
    gitCity(){
      this.dataForm.productAccessArea = JSON.stringify(this.$refs.cityRef.cityobj) 
      this.innerVisible = false
      console.log(this.dataForm.productAccessArea)
    },
    // /sys/mechanism/list
    async getpublishChannelsOptions() {
      // affiliatedInstitutions
            getList('/sys/dict/data/list?dataType=affiliatedInstitutions').then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              console.log(res)
              this.publishChannels=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.publishChannels.push({label:element.dictLabel,value:element.dictLabel})
                  })
              }
          }).catch(() => {})
       
      },
      
    async getwithdrawalOptions() {
      // affiliatedInstitutions
            getList('/sys/dict/data/list?dataType=prepayment').then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              console.log(res)
              this.withdrawal=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.withdrawal.push({label:element.dictLabel,value:element.dictLabel})
                  })
              }
          }).catch(() => {})
       
      },
    async getvipLevelOptions() {
            getList(`/sys/sluserviplevel/page`).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.vipLevels=[];
                if (res.data!=null){
                  res.data.list.forEach(element => {
                        this.vipLevels.push({label:element.name,value:element.logo})
                    })
                }
            }).catch(() => {})
      },
     //初始化下拉框中的选项
     async getCityOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.citys=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.citys.push({label:element.dictLabel,value:element.dictValue})
                  })
                  /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
              }
          }).catch(() => {})
      },
     
      async getproductCategoriesOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=product_categories`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.productCategories = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productCategories.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      // 上架配置
      // async getputawayOptions() {
      //     this.$http.get(`/sys/dict/data/list?dataType=putaway`).then(({ data: res }) => {
      //         if (res.code !== 0) {
      //             return this.$message.error(res.msg)
      //         }
      //          this.statusList = [];
      //         if (res.data!=null){
      //             res.data.forEach(element => {
      //              this.statusList.push({label: element.dictLabel ,value: element.dictValue})
      //             })
      //         }
      //     }).catch(() => {})
      // },
       // 产品对接方式
       async getproductTypesOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=productDockingMethod`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
             
               this.productTypes = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productTypes.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      async getcloseListCategoriesOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=closeType`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.closeList = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.closeList.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      async getProductTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=product_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.productTypeList = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productTypeList.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      // 申请流程
      async getapplyStepOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=productApplyFlow`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.productApplyFlow = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productApplyFlow.push({label: element.dictLabel ,value: element.dictLabel})
                  })
              }
          }).catch(() => {})
      },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slproduct/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
      
        let arr = []
        for (const key in res.data.applyStep) {
          arr.push(res.data.applyStep[key])
        }
       
        this.fileList.push({ url: res.data.productLogo })
        this.fileList1.push({ url: res.data.productDockingMethodUrl })
         
        this.dataForm = {
          ...this.dataForm,
          ...res.data,
          applyStep: arr,
        }
       
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
    
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
       
        let obj = {}
        this.dataForm.applyStep.forEach((item,index) => {
          obj[index+1] = item
        })
       
        
        // applyStep: { dto: obj}
        // this.dataForm.productPersonCondition = JSON.stringify(this.dataForm.productPersonCondition)
        // this.dataForm.productCreditRequirement = JSON.stringify(this.dataForm.productCreditRequirement)
        // this.dataForm.productCompanyCondition = JSON.stringify(this.dataForm.productCompanyCondition)
        // this.dataForm.productotherRequirement = JSON.stringify(this.dataForm.productotherRequirement)
        // this.dataForm.productApplyInfo = JSON.stringify(this.dataForm.productApplyInfo)
        // this.dataForm.productOtherRequirement = JSON.stringify(this.dataForm.productOtherRequirement)
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slproduct/',{ ...this.dataForm, applyStep: obj  }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>

.inline-box{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
   }
   .el-form-item{
    margin-right: 40px;
   }
.styW{
  width: 400px;
}
::v-deep .el-date-editor--date{
  width: 100%;
}
h3{
  margin: 30px 0;
}
.shareProfit{
  margin-left: 30px;
}
::v-deep .el-col{
  text-align: center;
  height: 40px;
  line-height: 40px;
}
::v-deep .el-input-number{
  width: 100px;
}

</style>
